import Content from "./content";
import { _ } from "~/i18n";
import { isPointInStatePolygon } from "~/util/state-polygon";

/**
 * @class Odkaz do katatstru.
 * @augments SMap.Detail.Content
 * @private
 */
export default class EstateLink extends Content {
	async _build() {
		if (this._data.source === "coor") {
			const wgs84 = this._data.coords.toWGS84();
			const stateCheck = await isPointInStatePolygon(wgs84[0], wgs84[1], {
				cs: true,
			});

			if (stateCheck) {
				const coords = this._data.coords.toJTSK();
				// API nema spravne JTSK -> prevod
				const jtsk = {
					x: Math.round(coords[1] * -1),
					y: Math.round(coords[0] * -1),
				};

				// vyuzijeme tridu pro odkazy
				this._dom.container.classList.add("content-link");

				const link = document.createElement("a");

				link.href = `http://nahlizenidokn.cuzk.cz/MapaIdentifikace.aspx?l=KN&x=${jtsk.x}&y=${jtsk.y}`;
				link.setAttribute("target", "_blank");
				link.innerHTML = _("detail.content.estatelink");

				this._dom.container.innerHTML = `<strong>${_("detail.content.otherlinks.title")}:</strong>`;
				this._dom.container.appendChild(link);
			}
		}
	}
}
